import React from 'react'
import PropTypes from 'prop-types'
import {
  Card, Form,
  Input, Button,
  Select, Icon,
} from 'antd'
import history from 'utils/history'

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 5,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 12,
    },
  },
}

const tailLayout = {
  wrapperCol: {
    xs: {
      offset: 24,
      span: 24,
    },
    sm: {
      offset: 5,
      span: 12,
    },
  },
}

const FormColek = ({
  handleSubmit,
  form, isEdit,
  isSubmitting,
  detailPakDe,
}) => {
  const {
    getFieldDecorator, validateFields,
  } = form

  return (
    <Card>
      <Form
        {...formItemLayout}
        onSubmit={(e) => {
          e.preventDefault()
          validateFields((err, values) => {
            if (!err) {
              handleSubmit(values)
            }
          })
        }}
      >
        <Form.Item label="Name">
          {getFieldDecorator('name', {
            initialValue: detailPakDe.name,
            rules: [{ required: !isEdit, message: 'Name wajib diisi' }],
          })(
            <Select
              placeholder="Select Name"
              disabled={isEdit}
            >
              <Select.Option value="before-post">Colek Teman Untuk Ikut Menabung</Select.Option>
              <Select.Option value="after-post">Teman Sudah Tercolek</Select.Option>
            </Select>,
          )}
        </Form.Item>
        <Form.Item label="Value">
          {getFieldDecorator('value', {
            initialValue: isEdit ? detailPakDe.value : '',
            rules: [{ required: true, message: 'Value wajib diisi' }],
          })(
            <Input.TextArea rows={4} placeholder="Input Value" />,
          )}
        </Form.Item>
        <Form.Item {...tailLayout} className="btn-primary-wrapper">
          <Button onClick={() => history.push('/content-management/colek-teman')} className="mr-2">Cancel</Button>
          <Button type="primary" htmlType="submit" disabled={isSubmitting}>
            {isSubmitting && <Icon type="loading" />}
            {!isEdit ? 'Add Item' : 'Submit Change'}
          </Button>
        </Form.Item>
      </Form>
    </Card>
  )
}

FormColek.propTypes = {
  handleSubmit: PropTypes.func,
  form: PropTypes.any,
  isEdit: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  detailPakDe: PropTypes.object,
}

export default Form.create({ name: 'colekForm' })(FormColek)
